import React, { useState } from "react";
import { motion } from "framer-motion";
import Head from "next/head";

export default function Demo() {
  const [select, setSelect] = useState("1");
  return (
    <>
      <Head>
        <title>Request a Demo | Background Verification Software India | CoinCircleTrust</title>
        <meta name="description" content="Experience the power of CoinCircleTrust's background verification software first-hand. Request a personalized demo today and see how we can help your business." />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify([
              {
                "@context": "https://schema.org",
                "@type": "BreadcrumbList",
                "itemListElement": [
                  {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Home",
                    "item": "https://www.coincircletrust.com/"
                  },
                  {
                    "@type": "ListItem",
                    "position": 2,
                    "name": "Request a Demo",
                    "item": "https://www.coincircletrust.com/demo"
                  }
                ]
              }
            ]),
          }}
        />
      </Head>
      <section className="container-padding-x mb-[80px]">
        <div className="relative mt-12 lg:mt-24 grid lg:grid-cols-[35%,60%] grid-cols-1 lg:items-center lg:space-x-16">
          <div className="relative col-span-2 lg:col-span-1 lg:mr-auto">
            <div className="mt-2 space-y-6 group" onClick={() => {
              setSelect("1");
            }}>
              <div className={`relative cursor-pointer py-[24px] px-[16px] transition-all ease-in-out duration-100 ${select === "1" ? "border border-tranparent bg-slate-50/50" : ""}`}>
                <div class="ml-4">
                  <p class={`text-[24px] leading-[24px] font-bold ${select === "1" ? "text-[#0481A0]" : "text-black"}`}>Create an Account &amp; Order</p>
                  <p x-text="feature.description" class="mt-2 text-sm md:text-base text-gray-500">Get started in less than 2 minutes!</p>
                </div>
              </div>
            </div>
            <div className="mt-2 space-y-6 group" onClick={() => {
              setSelect("2");
            }}>
              <div className={`relative cursor-pointer py-[24px] px-[16px] transition-all ease-in-out duration-100 ${select === "2" ? "border border-tranparent bg-slate-50/50" : ""}`}>
                <div class="ml-4">
                  <p class={`text-[24px] leading-[24px] font-bold ${select === "2" ? "text-[#0481A0]" : "text-black"}`}>Candidate Disclosures &amp; Application</p>
                  <p x-text="feature.description" class="mt-2 text-sm md:text-base text-gray-500">See what your applicants will need to fill out to complete their background check</p>
                </div>
              </div>
            </div>
            <div className="mt-2 space-y-6 group" onClick={() => {
              setSelect("3");
            }}>
              <div className={`relative cursor-pointer py-[24px] px-[16px] transition-all ease-in-out duration-100 ${select === "3" ? "border border-tranparent bg-slate-50/50" : ""}`}>
                <div class="ml-4">
                  <p class={`text-[24px] leading-[24px] font-bold ${select === "3" ? "text-[#0481A0]" : "text-black"}`}>View a Background Report</p>
                  <p x-text="feature.description" class="mt-2 text-sm md:text-base text-gray-500">Easily review consolidated background reports</p>
                </div>
              </div>
            </div>
          </div>
          <div className="lg:flex relative col-span-1 items-center py-8 h-full">
            {select === "1" ? <iframe
              src="https://demo.arcade.software/o0uIunFv78JXT3XWtFVt?embed"
              title="CoinCircleTrust TRUST, VERIFY, SUCCEED"
              frameborder="0"
              loading="lazy"
              webkitallowfullscreen
              mozallowfullscreen
              allowfullscreen
              style={{
                position: "absolute",
                top: "0",
                left: "0",
                width: "100%",
                height: "100%",
                colorScheme: "light",
              }}
              className="w-full aspect-[4/3]"
            ></iframe> : ""}
            {select === "2" ? <iframe
              src="https://demo.arcade.software/o0uIunFv78JXT3XWtFVt?embed"
              title="CoinCircleTrust TRUST, VERIFY, SUCCEED"
              frameborder="0"
              loading="lazy"
              webkitallowfullscreen
              mozallowfullscreen
              allowfullscreen
              style={{
                position: "absolute",
                top: "0",
                left: "0",
                width: "100%",
                height: "100%",
                colorScheme: "light",
              }}
              className="w-full aspect-[4/3]"
            ></iframe> : ""}
            {select === "3" ? <iframe
              src="https://demo.arcade.software/o0uIunFv78JXT3XWtFVt?embed"
              title="CoinCircleTrust TRUST, VERIFY, SUCCEED"
              frameborder="0"
              loading="lazy"
              webkitallowfullscreen
              mozallowfullscreen
              allowfullscreen
              style={{
                position: "absolute",
                top: "0",
                left: "0",
                width: "100%",
                height: "100%",
                colorScheme: "light",
              }}
              className="w-full aspect-[4/3]"
            ></iframe> : ""}
          </div>
        </div>
      </section>
      {/* <section>
        <div
          style={{
            position: "relative",
            paddingBottom: "calc(43.65234375% + 41px)",
            height: 0,
            width: "100%",
          }}
        >
          <iframe
            src="https://demo.arcade.software/fMbW42AP8rvLfuK7UJWR?embed"
            title="CoinCircleTrust TRUST, VERIFY, SUCCEED"
            frameborder="0"
            loading="lazy"
            webkitallowfullscreen
            mozallowfullscreen
            allowfullscreen
            style={{
              position: "absolute",
              top: "0",
              left: "0",
              width: "100%",
              height: "100%",
              colorScheme: "light",
            }}
          ></iframe>
        </div>
      </section> */}
    </>
  );
}
